import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  private KEY_SECRET: string = `${environment.GNR_GENERIC_KEY_SECRET}`;

  encrypt(plainText: string): string {
    // Parsear la clave como UTF-8
    const key = CryptoJS.enc.Utf8.parse(this.KEY_SECRET);
    const encrypted = CryptoJS.AES.encrypt(plainText, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }
}
